import { useDispatch, useSelector } from '../../../../store/store';
import { setSignUpStep } from '../../../../store/signUp/slice';
import MotionWrapper from '../../../../layouts/MotionWrapper';
import { useCountDown } from '../../../../hooks/useCountDown';
import { TypographyLogo } from '../../../../assets/icons';
import { toTime } from '../../../../utils/generalHelpers';
import Button from '../../../../components/Button';
import OTP from '../../../../components/OTP';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    selectEmail,
    selectSignUpStep,
    selectFetchStatus,
    selectPhoneNumber,
    selectSignUpMode,
} from '../../../../store/signUp/selectors';
import {
    confirmSignUpThunk,
    confirmPhoneNumberThunk,
    resendEmailConfirmationCodeThunk,
    resendPhoneNumberConfirmationCodeThunk,
} from '../../../../store/signUp/thunks';

function Verify() {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState('');
    const email = useSelector(selectEmail);
    const step = useSelector(selectSignUpStep);
    const mode = useSelector(selectSignUpMode);
    const fetchStatus = useSelector(selectFetchStatus);
    const phoneNumber = useSelector(selectPhoneNumber);
    const { counter, restart } = useCountDown(180, 'start');
    const { minutes, seconds } = toTime(counter);

    useEffect(() => {
        if (otp.length === 6) next();
    }, [otp]);

    const next = async () => {
        switch (step) {
            case 'verifyEmail': {
                dispatch(confirmSignUpThunk({ username: email, confirmationCode: otp, mode }));
                break;
            }
            case 'verifyPhoneNumber': {
                dispatch(confirmPhoneNumberThunk(otp));
                break;
            }
            default:
                return;
        }
    };

    const resendOTPCode = () => {
        if (counter > 0) return;
        restart();
        switch (step) {
            case 'verifyEmail':
                dispatch(resendEmailConfirmationCodeThunk(email));
                break;
            case 'verifyPhoneNumber':
                dispatch(resendPhoneNumberConfirmationCodeThunk());
                break;
            default:
                return;
        }
    };

    const changeMailOrPhone = () => {
        const nextStep = step === 'verifyEmail' ? 'registerEmail' : 'employerInfo';
        dispatch(setSignUpStep(nextStep));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Sign Up</span>
            </div>
            <span className={styles.description}>
                Verify your Account, enter the Sent Code to:
            </span>
            <div className={styles.detail}>
                <div className={styles.detail_email}>
                    <span>{step === 'verifyPhoneNumber' ? phoneNumber : email}</span>
                </div>
                <span
                    onClick={changeMailOrPhone}
                    className={styles.detail_change_mail}
                >
                    Change {step === 'verifyEmail' ? 'e-mail' : 'phone number'}
                </span>
            </div>
            <OTP
                value={otp}
                onChange={setOtp}
                numInputs={6}
                onChangeRegex={/^([0-9]{0,})$/}
            />
            <div className={styles.counter}>
                {counter > 0 ? <span className={styles.counter_time}>
                    {minutes}:{seconds} minutes to new one time password
                </span> :
                    <span
                        data-is-deactive={counter > 0}
                        onClick={resendOTPCode}
                        className={styles.counter_resend}
                    >
                        Resend code
                    </span>}
            </div>
            <Button
                text="Confirm"
                onClick={next}
                loading={fetchStatus === 'Pending'}
                disabled={otp.length !== 6}
                className={styles.next}
            />
        </MotionWrapper>
    );
};

export default Verify;
